module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_ext_06_6DC79_1SD_GKK.6518c19d.png";